import React, { useState } from 'react';
import { useNavigate, Navigate, Link } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';

export default function AdminLogin() {
  const { login, admin, checking } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (checking) return null;
  if (admin) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success('Welcome back, Rhea.');
      navigate('/admin');
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'Login failed.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f5f1e8] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-baseline gap-1 mb-12">
          <span className="font-serif text-4xl text-[#1a3a2e]">rg</span>
          <span className="font-serif text-4xl text-[#8b5a2b]">.</span>
        </Link>
        <h1 className="font-serif text-4xl text-[#1a3a2e]">Admin sign in</h1>
        <p className="mt-2 text-sm text-[#3a5a4e]">Manage campaigns & enquiries.</p>

        <form onSubmit={onSubmit} className="mt-10 space-y-6" data-testid="admin-login-form">
          <div>
            <label className="text-xs tracking-[0.25em] uppercase text-[#3a5a4e]">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-login-email"
              className="mt-3 block w-full bg-transparent border-b border-[#1a3a2e]/30 focus:border-[#1a3a2e] py-3 text-[#1a3a2e]"
            />
          </div>
          <div>
            <label className="text-xs tracking-[0.25em] uppercase text-[#3a5a4e]">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-login-password"
              className="mt-3 block w-full bg-transparent border-b border-[#1a3a2e]/30 focus:border-[#1a3a2e] py-3 text-[#1a3a2e]"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="w-full px-7 py-4 bg-[#1a3a2e] text-[#f5f1e8] text-sm tracking-wide hover:bg-[#122a21] transition-colors disabled:opacity-60"
          >
            {submitting ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
